enum ControleReclamacaoTipo {
    Venda = 1,
    Lote = 2,
}

export default ControleReclamacaoTipo;
